var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00025 2.99975C8.25625 2.99975 8.51225 3.09775 8.70725 3.29275L16.7072 11.2928C17.0982 11.6838 17.0982 12.3157 16.7072 12.7067L8.70725 20.7068C8.31625 21.0978 7.68425 21.0978 7.29325 20.7068C6.90225 20.3158 6.90225 19.6838 7.29325 19.2928L14.5862 11.9998L7.29325 4.70675C6.90225 4.31575 6.90225 3.68375 7.29325 3.29275C7.48825 3.09775 7.74425 2.99975 8.00025 2.99975",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrowRightIcon.bbd5b5bcbf4cfe74a0610b38b73eb55d.svg";
export { ForwardRef as ReactComponent };